module.exports = __webpack_public_path__ + "static/media/corsair-hs50.18f2d22a.jpg";